export default __webpack_public_path__ + "static/media/eixo.87ce3687.png";